<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" @click="$router.go(-1)"></div>
      </div>
      <div class="mini-header">横幅设置</div>
      <div class="newvote">
        <Button class="btn-dc" @click="setModule" :loading="btnLoading">保存</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px">
        <div style="font-size: 20px;font-weight: 600">数据维护</div>
        <div class="i-title">
          <label class="i-label">是否在首页展示该模块</label>
          <RadioGroup v-model="showModule" style="margin-top: -5px;margin-left: 10px;color: #999">
            <Radio :label='1'>是</Radio>
            <Radio :label='0'>否</Radio>
          </RadioGroup>
        </div>
        <div class="i-title">
          <label class="i-label">关联模块</label>
          <Select v-model="moduleId" style="width:360px;margin-left: 10px" @on-change="moduleChange">
            <Option
              v-for="item in moduleList"
              :value="item.id"
              :key="item.id"
            >{{ item.name }}</Option>
          </Select>
        </div>
        <div class="i-title">
          <label class="i-label">横幅图片</label>
          <img v-if="bannerUrl" :src="bannerUrl" class="banner-pic" />
        </div>
      </Card>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'bannerSet',
    data () {
      return {
        id:'',
        moduleList:[],
        moduleId:'',
        showModule:'',
        bannerUrl:'',
        btnLoading:false,
        moduleName:''
      }
    },
    methods: {
      getSetting() {
        var url = this.urlobj.getMstSetting+'?appType='+this.$store.state.apptype
        this.$get(url).then(res => {
          var item = res.newPrimaryKeys.home_banner
          this.bannerUrl = item.iconUrl
          this.showModule = item.isShow
          this.moduleId = item.moduleId
          this.moduleName = item.moduleName
          this.id = item.id
        })
      },
      getMoudle() {
        var url = this.urlobj.getConnectModel;
        var data = {type: 'home_banner'};
        this.$post(url, data)
          .then(res => {
            this.moduleList = res.rows.map(item => {
              return {
                id: item.id,
                name: item.moduleName,
                url: item.iconUrl
              };
            });
            this.getSetting()
          })
          .catch(e => {

          });
      },
      moduleChange (val) {
        this.moduleList.forEach(item => {
          if (item.id == val) {
            this.bannerUrl = item.url
            this.moduleName = item.name
          }
        })
      },
      setModule () {
        var url = this.urlobj.setModule
        this.btnLoading = true
        this.$post(url,{
          id:this.id,
          moduleId:this.moduleId,
          isShow:this.showModule,
          moduleName:this.moduleName,
          iconUrl:this.bannerUrl
        }).then(res => {
          this.btnLoading = false
          this.$Message.success('保存成功')
        }).catch(e => {
          this.btnLoading = false
          this.$Message.error('保存失败')
        })
      }
    },
    mounted() {
      this.getMoudle()

    }
  }
</script>

<style scoped lang="less">
  .left {
    position: absolute;
    left: 20px;
    font-size: 22px;
    .iconfont {
      font-size: 26px;
      color: #999;
    }
  }

  .newvote {
    position: absolute;
    right: 20px;
    button {
      min-width: 60px;
      height: 28px;
      line-height: 13px;
    }
  }

  .mini-header-wrapper {
    display: flex;
    /*height: 30px;*/
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
  }

  .mini-header {
    font-size: 25px;
    text-align: center;
  }

  .item-wrapper {
    padding-left: 20px;
  }
  .i-title {
    display: flex;
    align-items: center;
  }
  .i-label {
    min-width: 140px;
    white-space: nowrap;
    text-align: right;
    font-size: 14px;
    color: #666;
    margin: 15px 10px 15px 0;
  }
  .banner-pic{
    height: 85px;
    width: 360px;
    margin-left: 10px;
  }
</style>
